// Module
var code = `<div ng-if="\$ctrl.failure" class="jumbotron-note-box is-bad curator-sync-status" role="status">
  <div class="curator-sync-status-headline">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    {{\$ctrl.failure.headline}} New posts do not come in.
  </div>
  <div>
    <span ng-if="\$ctrl.failure.since">Fails since {{\$ctrl.failure.since}}.</span>
    {{\$ctrl.failure.lastSuccess}}
  </div>
  <div class="curator-sync-status-detail">Curator says: {{\$ctrl.failure.message}}</div>
</div>
`;
// Exports
export default code;